import { createFileRoute } from "@tanstack/react-router"
import { DashboardRecentActivityPage } from "@/pages"

export const Route = createFileRoute(
  "/_authenticated/_organization/dashboard/recent-activity"
)({
  component: DashboardRecentActivityPage,
})
